import subjects from './filters/subjects'
import floorplans from './common/floorplans'
import project from './common/project'

export default {
    data: {
        getProject: {
            ...project,
            subjects,
            floorplans,
        },
    },
}
